import React from "react";
import { useState } from "react";
import { Typography, Divider, useMediaQuery } from "@mui/material";
import "@fontsource/rubik/500.css";
import "@fontsource/rubik/400.css";
import ExpandInfo from "./ExpandInfo";

const Step2Casnic = () => {
  const isLaptop = useMediaQuery("(max-width: 1400px)");
  const isMobile = useMediaQuery("(max-width: 1024px)");

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          marginLeft: isMobile ? 0 : "140px",
          marginRight: isMobile ? -20 : "140px",
          marginTop: isMobile ? -50 : "50px",
        }}
      >
        {!isMobile ? (
          <Divider
            orientation="vertical"
            sx={{
              height: isLaptop ? "44rem" : "30rem",
              width: "4px",
              backgroundColor: "#29348f",
            }}
          />
        ) : (
          ""
        )}
        <div style={{ marginLeft: 34 }}>
          <div
            variant="contained"
            style={{
              backgroundColor: "#29348f",
              borderRadius: isMobile
                ? "20px 0px 0px 20px"
                : "0px 20px 20px 0px",
              textTransform: "none",
              height: 40,
              width: 80,
              paddingLeft: 16,
              paddingTop: 8,
              marginLeft: isMobile ? "auto" : "",
            }}
          >
            <Typography variant="body1" color="white">
              Client
            </Typography>
          </div>
          <Typography variant="h6" sx={{ mt: 4 }}>
            Depunerea cererii de racordare și a documentelor aferente
          </Typography>
          <Typography variant="body2" sx={{ mt: 2 }}>
            Informații generale privind condițiile și posibilitățile de
            realizare a racordării la rețea a locului de consum și/sau de
            producere:
          </Typography>

          <Typography variant="body2" sx={{ mt: 2 }}>
            Personal, la Centrele de Relații cu Utilizatorii;
          </Typography>
          {/* <Typography variant="body2" sx={{ mt: 0 }}>
            E-mail, la adresa: office@distributie-energie.ro;
          </Typography> */}
          <Typography variant="body2" sx={{ mt: 0 }}>
            Poștă/curier;
          </Typography>
          <Typography variant="body2" sx={{ mt: 0 }}>
            Canale de comunicare electronică (portal).
          </Typography>
          <Typography variant="body2" sx={{ mt: 0 }}>
            Prin împuternicit în numele și pe seama solicitantului;
          </Typography>
          <Typography variant="body2" sx={{ mt: 0 }}>
            Prin furnizorul de energie electrică în numele și pe seama
            solicitantului, pentru locurile de consum aferente clienților
            casnici;
          </Typography>
          <Typography variant="body2" sx={{ mt: 0 }}>
            Adresele de corespondență le găsiți pe site-ul DEER la {""}
            <a
              href="https://www.distributie-energie.ro/informatii-generale/"
              style={{ color: "#0D6D92" }}
            >
              adrese de corespondență
            </a>
          </Typography>

          <Typography variant="h6" sx={{ mt: 2, fontWeight: "500" }}>
            Cererea de racordare este necesar să fie însoțită de urmatoarele
            documente{" "}
          </Typography>

          <Typography variant="body2" sx={{ mt: 2 }}>
            <a
              href="./Declaratie-autenticitate-date-racordare.doc"
              style={{ color: "#0D6D92" }}
            >
              {" "}
              Declaratie autenticitate date - cerere racordare{" "}
            </a>{" "}
            – Obligatoriu pentru toate tipurile de cereri
          </Typography>

          <Typography variant="body2" sx={{ mt: 0 }}>
            <a
              href="./12-Model-de-imputernicire.pdf"
              style={{ color: "#0D6D92" }}
            >
              {" "}
              Model imputernicire{" "}
            </a>{" "}
            – În cazul în care cererea se depune prin împuternicit{" "}
          </Typography>
          <Typography variant="body2" sx={{ mt: 0 }}>
            <a
              href="./Nota-informare-clienti-DEER-final.doc"
              style={{ color: "#0D6D92" }}
            >
              {" "}
              Nota de informare generală privind prelucrarea datelor cu caracter
              personal{" "}
            </a>{" "}
            – În cazul persoanelor fizice{" "}
          </Typography>

          <Typography variant="h6" sx={{ mt: 2, color: "#29348f" }}>
            Cât durează?
          </Typography>

          <Typography variant="body2" sx={{ mt: 2 }}>
            În termen de 10 zile lucrătoare de la data înregistrării cererii de
            racordare sau a cererii de actualizare a avizului tehnic de
            racordare/certificatului de racordare, operatorul de reţea verifică
            documentaţia depusă.
          </Typography>
        </div>
        {isMobile ? (
          <Divider
            orientation="vertical"
            sx={{
              height: "62rem",
              width: "4px",
              backgroundColor: "#29348f",
              ml: 2,
            }}
          />
        ) : (
          ""
        )}
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          marginLeft: isMobile ? -30 : "140px",
          marginTop: "50px",
          marginRight: isMobile ? 0 : "140px",
          marginBottom: "60px",
        }}
      >
        <Divider
          orientation="vertical"
          sx={{
            height: "4rem",
            width: "4px",
            backgroundColor: "#29348f",
            mr: isMobile ? 3 : "",
          }}
        />
        <ExpandInfo />
      </div>
    </div>
  );
};
export default Step2Casnic;
